// extracted by mini-css-extract-plugin
module.exports = {"rating-icon-pill":"styles-module__rating-icon-pill___1Quru","score":"styles-module__score___1QM97"};